<p-toast position="top-right"></p-toast>
<div class="p-g">
    <div class="p-g-12">
        <div class="card card-w-title trainerAttendanceMarking">

            <p-dialog style="font-weight: 600;" [header]='setLabel("trainingSessionsHeaderLabel")'
                (onHide)="hideModal()" [(visible)]="trainingSessionsDialog" class="dialogPop">
                <form class="payout-main-wrapper" #TrainingSessionsDialogForm="ngForm"
                    style="width: 320px; text-align: inherit;">
                    <div *ngIf="allowReschedule" class="payout-fields payout-field-checkbox">
                        <p-checkbox [label]='setLabel("rescheduleLabel")' [(ngModel)]="reschedule" [binary]="true" name="reschedule"></p-checkbox>
                    </div>
                    <div *ngIf="!reschedule">
                        <div class="payout-fields">
                            <span class="label">Package Name:</span>
                            <span class="bind">{{ servicesPackageName }}</span>
                        </div>
                        <span class="p-g-12"></span>
                        <div class="payout-fields">
                            <span class="label">{{setLabel("memberNameLabel")}}</span>
                            <span class="bind">{{ memberName }}</span>
                        </div>
                        <span class="p-g-12"></span>

                        <span class="p-g-12"></span>
                        <div class="payout-fields">
                            <span class="label">{{setLabel("statusLabel")}}</span>
                            <span class="bind">{{ status}}</span>
                        </div>
                        <span class="p-g-12"></span>
                        <div *ngIf="allowAttendance" class="p-g-12" style="margin-top: 20px;display: flex;gap: 20px">
                            <button class="p-g-6" type="button" pButton (click)="markPresent()"
                                [label]='setLabel("presentLabel")'
                                style="margin-right: 10px; background-color: #4CAF50;"></button>
                            <button class="p-g-6" type="button" pButton (click)="markAbsent()"
                                [label]='setLabel("absentLabel")' style="background-color: #F44336;"></button>
                        </div>
                    </div>
                    <div class="payout-fields" *ngIf="reschedule" style="display: flex; ">
                        <span class="label">{{setLabel("selectDateLabel")}} </span>
                        <p-calendar [yearNavigator]="true" appendTo="body" yearRange="1950:2040" [monthNavigator]="true"
                            [(ngModel)]="selectedDate" [placeholder]='setLabel("rescheduleDatePlaceholderLabel")'
                            name="createdDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                        </p-calendar>
                    </div>
                    <div ngClass="payout-fields" *ngIf="reschedule" class="p-g-12"
                        style="margin-top: 20px; display: flex;justify-content: center;">
                        <button type="button" pButton (click)="rescheduleSession()"
                            [label]='setLabel("rescheduleLabel")'
                            style="margin-right: 10px; background-color: rgb(80, 120, 252);"></button>
                    </div>
                </form>
            </p-dialog>
            <p-dialog style="font-weight: 600;" header="Class Training"
                (onHide)="hideModal()" [(visible)]="classSessionsDialog" class="dialogPop">
                <form class="payout-main-wrapper" #TrainingSessionsDialogForm="ngForm"
                    style="width: 320px; text-align: inherit;">
                    <div >
                        <span >Trainer Name: </span>
                        <span style="font-weight: lighter;" >{{ classTrainerName }}</span>
                    </div>
                    <div *ngFor="let member of members" style="display: flex; justify-content: space-between;align-items: center;">
                        <label style="display: block;">
                            {{ member.name }}
                        </label>
                        <input type="checkbox" style="width: auto;" [checked]="member.attendedStatus === 'ATTENDED'" (change)="changeAttendedStatus(member)">
                    </div>
                    <div>
                        <button type="button" pButton (click)="markClassAttendance()"
                            label="Mark Class Attendance"
                            style="margin-right: 10px; background-color: rgb(80, 120, 252);"></button>
                    </div>
                </form>
            </p-dialog>
            <p-panel [header]='setLabel("trainingSessionsHeaderLabel")'
                [style]="{ height: '100%', 'margin-top': '4px' }" class="calenderHeader">
                <full-calendar [events]="events" [options]="scheduleOptions"></full-calendar>
            </p-panel>
        </div>
    </div>
</div>